import { render } from "./ConfigureWorkflow.vue?vue&type=template&id=4c6ed59b"
import script from "./ConfigureWorkflow.vue?vue&type=script&lang=js"
export * from "./ConfigureWorkflow.vue?vue&type=script&lang=js"

import "./ConfigureWorkflow.vue?vue&type=style&index=0&id=4c6ed59b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__